const basePath = window.location.origin + process.env.PUBLIC_URL;

export const Globals = {
    window: (): any => window as any,
    navigator: (): typeof navigator => navigator,
    document: (): Document => document,
    body: (): HTMLElement => document.body,
    timestamp: (): number => Date.now(),
    basePath,
    origin: (): string => window.location.origin,
};
